/* global _, $, Rx, virtualDom, Promise, console */
import {convertName, getFabs} from "./_utilities";

/**
 * setup Interior Builder
 * @param selector
 * @param state
 * @returns {{}}
 */
export function setupInteriorBuilder(selector, state, store) {
	const canvasWidth = 4096,
		canvasHeight = 2048;

	let interiorViewer = {},
		imgFolder,
		md = new MobileDetect(window.navigator.userAgent),
		mobile = md.mobile(),
		targetLat = 0, targetLon = 0,
		container, $container,
		camera,
		prevCameraTarget = {
			x: 0,
			y: 0,
			z: 0
		},
		scene, renderer,
		raycaster, mouse = new THREE.Vector2(), INTERSECTED,
		controls,
		canvas, context,
		layerMesh,
		layerTexture, layerGeometry, layerMaterial,
		hotspotCanvas = document.createElement("canvas"),
		hotspotCanvasContext,
		hotspots,
		hotspotGeometry = new THREE.PlaneGeometry(64, 64, 1),
		hotspotMaterial,
		hotspotTexture = new THREE.Texture(hotspotCanvas),
		isUserInteracting = false,
		onPointerDownPointerX = 0, onPointerDownPointerY = 0,
		lon = 0, onPointerDownLon = 0,
		lat = 0, onPointerDownLat = 0,
		phi = 0, theta = 0,
		radius = state.interiorViewRadius,
		animFactor = 0.1,
		animPrecision = 0.1,
		moveFactor = mobile ? 0.5 : 0.1,
		viewInitRotationDegrees = mobile ? 180 : -90,
		jitterThreshold = 0.0005,
		animateMovement = true,
		$progressBarMask,
		$progressBarCircle,
		// should the viewer run
		run = false;

	function setupViewer() {

		$container = $(selector);
		// loader
		$progressBarMask = $('<div class="progress-bar-mask"><div class="progress-bar-wrap"><div class="progress-bar-circle"></div></div></div>').appendTo($container);
		$progressBarCircle = new ProgressBar.Circle($progressBarMask.find(".progress-bar-circle")[0], {
			color: "#fff",
			// This has to be the same size as the maximum width to
			// prevent clipping
			strokeWidth: 4,
			trailWidth: 4,
			easing: 'easeInOut',
			duration: 1400,
			text: {
				autoStyleContainer: false
			},
			from: {color: '#e5e5e5', width: 4},
			to: {color: '#5482ab', width: 4},
			// Set default step function for all animate calls
			step: function (state, circle) {
				circle.path.setAttribute('stroke', state.color);
				circle.path.setAttribute('stroke-width', state.width);

				var value = Math.round(circle.value() * 100);
				if (value === 0) {
					circle.setText('');
				} else {
					circle.setText("LOADING " + value + "%");
				}

			}
		});

		container = $container[0];

		raycaster = new THREE.Raycaster();

		hotspotCanvas.width = 64;
		hotspotCanvas.height = 64;
		hotspotCanvasContext = hotspotCanvas.getContext("2d");
		hotspotMaterial = new THREE.MeshBasicMaterial({
			map: hotspotTexture,
			transparent: true
		});

		Rx.Observable.fromPromise(getImage("/images/inactive-hotspot-icon.png"))
			.subscribe(imgData => {
				console.log("hotspot image", imgData);
				hotspotCanvasContext.drawImage(imgData.img, 0, 0,
					imgData.img.width, imgData.img.height,
					0, 0,
					imgData.img.width, imgData.img.height);

			}, e => {
				console.log(e)
			},
			() => {
				console.log("loaded hotspot icon")
				hotspotTexture.needsUpdate = true;
			});

		canvas = document.createElement("canvas");
		canvas.width = canvasWidth;
		canvas.height = canvasHeight;
		context = canvas.getContext("2d");
		context.globalCompositeOperation = "source-over";

		renderer = new THREE.WebGLRenderer();
		renderer.setPixelRatio(window.devicePixelRatio);
		renderer.setSize(container.clientWidth, container.clientHeight);
		renderer.domElement.style.position = 'absolute';
		renderer.domElement.style.top = 0;

		renderer.sortObjects = false;

		container.appendChild(renderer.domElement);

		scene = new THREE.Scene();

		camera = new THREE.PerspectiveCamera(75, container.clientWidth / container.clientHeight, 1, 1100);
		camera.target = new THREE.Vector3(0, 0, 0);

		layerTexture = new THREE.Texture(canvas);
		layerTexture.needsUpdate = true;
		layerGeometry = new THREE.SphereGeometry(500, 60, 40);
		layerGeometry.scale(-1, 1, 1);
		layerMaterial = new THREE.MeshBasicMaterial({
			map: layerTexture,
			transparent: true
		});
		layerMesh = new THREE.Mesh(layerGeometry, layerMaterial);
		if (mobile) {
			layerMesh.rotation.y = THREE.Math.radToDeg(viewInitRotationDegrees);
		}
		scene.add(layerMesh);

		hotspotTexture.needsUpdate = true;

		interiorViewer.showHotspots = true;

		if (mobile) {
			controls = new DeviceOrientationController(camera, renderer.domElement);
			controls.enableManualDrag = false;
			controls.connect();
			// controls = new THREE.DeviceOrientationControls(camera);
			// controls.enableDamping = true;
			// controls.dampingFactor = 0.25;
			// controls.enableZoom = false;
			// controls.rotateSpeed = 0.2;
			// // reverse initial angle so looking out the front of the truck
			// //controls.alphaOffsetAngle = Math.PI;
		}
		// else {
		// 	controls = new THREE.OrbitControls(camera, renderer.domElement);
		// 	controls.enableDamping = true;
		// 	controls.dampingFactor = 0.25;
		// 	controls.enableZoom = false;
		// 	controls.rotateSpeed = 0.2;
		// }



		container.addEventListener('mousedown', onDocumentMoveStart, false);
		container.addEventListener('mousemove', onDocumentMove, false);
		container.addEventListener('mouseup', onDocumentMoveEnd, false);
		container.addEventListener('touchstart', onDocumentMoveStart, false);
		container.addEventListener('touchmove', onDocumentMove, false);
		container.addEventListener('touchend', onDocumentMoveEnd, false);
		container.addEventListener('mousewheel', onDocumentMouseWheel, false);
		// container.addEventListener('click', onDocumentClick, false);
		container.addEventListener('MozMousePixelScroll', onDocumentMouseWheel, false);

		window.addEventListener('resize', updateRendererSize, false);

		var tap$ = Rx.Observable.merge(
			Rx.Observable.fromEvent(container, "mousedown"),
			Rx.Observable.fromEvent(container, "touchstart")
		);

		Rx.Observable.interval(50)
			.takeUntil(tap$)
			.filter(() => run)
			.subscribe(() => {
				//console.log("auto rotating", onPointerDownPointerX, onPointerDownLon, lon);
				onPointerDownPointerX += 10;
				onPointerDownLon = lon;
				targetLon = 10 * moveFactor + onPointerDownLon;
			});

	}

	function updateProgress(i, l, x, c, r, min = 0, max = 1) {
		var target = l > 0 ? l : 1,
			progress = min + ((i / target) * max);
		// console.log("update progress: ", i, l, min, max, progress, c, r);

		if (r) {
			if (progress >= 0) {
				$progressBarLineWrap.show();
			}
			$progressBarLine.animate(progress);
			if (c) {
				$progressBarLineWrap.hide();
				$progressBarLine.set(0);
			}
		} else {
			if (progress >= 0) {
				$progressBarMask.show();
			}

			$progressBarCircle.animate(progress);
			if (c) {
				$progressBarMask.hide();
				$progressBarCircle.set(0);
			}
		}
		return {
			current: x,
			progress: progress,
			r
		};
	}

	function getFileName(dir, layerName) {
		var p = new Promise((resolve, reject) => {
			$.ajax({
				url: "../getImage.php?dir=" + dir + "&image=" + layerName[0],
				// url: "https://freightlinertrucks-staging.azurewebsites.net/umbraco/surface/configurator/getImages?" +
				// "dir=" + dir + "&image=" + layerName,
				method: 'GET',
				dataType: "json"
			}).then(function (filename) {
				console.log(dir, layerName, filename);
				resolve(filename);
			}, function (error) {
				reject(error);
			});
		});
		return p;
	}

	function update() {
		var latDiff,
			lonDiff,
			coords;

		// calculate the current lat/lon given the target lat/lon and animation status
		if (!animateMovement) {
			lat = targetLat;
			lon = targetLon;
			animateMovement = true;
		} else {
			latDiff = absoluteDiff(lat, targetLat);
			lonDiff = absoluteDiff(lon, targetLon);

			if (latDiff > animPrecision) {
				if (lat > targetLat) {
					lat = lat - (latDiff * animFactor);
				} else {
					lat = lat + (latDiff * animFactor);
				}
			} else {
				targetLat = lat;
			}
			if (lonDiff > animPrecision) {
				if (lon > targetLon) {
					lon = lon - (lonDiff * animFactor);
				} else {
					lon = lon + (lonDiff * animFactor);
				}
			} else {
				targetLon = lon;
			}
		}

		// convert lat/lon to x,y,z coords to point the camera there
		coords = getCartesianCoordinatesOnSphereFromLonLat(lat, lon, radius);
		// camera.target.set(coords.x, coords.y, coords.z);
		// camera.lookAt(camera.target);
		if (!mobile) {
			layerMesh.rotation.x = -THREE.Math.degToRad(lat);
		}
		layerMesh.rotation.y = THREE.Math.degToRad(lon + viewInitRotationDegrees);

		if (typeof Stats === "function") {
			stats.update();
		}


		// update view based on deviceorientation
		if (mobile) {
			// console.log("mobile", md.mobile());
			controls.update();
		}

		let v = new THREE.Vector3(0, 0, -1);
		v.applyQuaternion(camera.quaternion);

		if (interiorViewer.showHotspots
			&&
			(Math.abs(v.x - prevCameraTarget.x) > jitterThreshold||
			 Math.abs(v.y - prevCameraTarget.y) > jitterThreshold ||
			 Math.abs(v.z - prevCameraTarget.z) > jitterThreshold)) {


			console.log("camera has moved");

			// make the hotspots face the camera - billboard style
			// _.forEach(hotspots, function (hotspot) {
			// 	hotspot.quaternion.copy(camera.quaternion);
			// });
			_.forEach(hotspots, function (hotspot) {
				// hotspot.quaternion.copy(camera.quaternion);
				hotspot.lookAt(new THREE.Vector3(0,0,0))
			});

			// move the labels with the hotspots
			// camera.updateMatrix(); // make sure camera's local matrix is updated
			// camera.updateMatrixWorld(); // make sure camera's world matrix is updated
			// camera.matrixWorldInverse.getInverse(camera.matrixWorld);
			// let frustum = new THREE.Frustum();
			// frustum.setFromMatrix(new THREE.Matrix4().multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse));
			// $container.find(".hotspot-label").each(function () {
			// 	var $label = $(this),
			// 		hotspot = $(this).data("hotspot"),
			// 		vector = convert3DWorldTo2DScreen(hotspot, camera, renderer);
			// 	$label.css({
			// 		left: vector.x - $label.width() / 2,
			// 		top: vector.y - $label.height() / 2,
			// 		display: frustum.containsPoint(hotspot.position) ? "block" : "none"
			// 	});
			// 	//console.log(vector.x, vector.y);
			// });


		} else if (!interiorViewer.showHotspots) {
			$(".hotspot-label").each(function () {
				$(this).css({
					"display": "none"
				})
			});
		}

		checkHotspotHovers();

		prevCameraTarget.x = v.x;
		prevCameraTarget.y = v.y;
		prevCameraTarget.z = v.z;


		renderer.render(scene, camera);
	}

	function checkHotspotHovers() {
		// find intersections

		raycaster.setFromCamera(mouse, camera);

		var intersects = raycaster.intersectObjects(hotspots);

		if (intersects.length > 0) {

			if (INTERSECTED != intersects[0].object) {

				INTERSECTED = intersects[0].object;

				INTERSECTED.userData.rotation = camera.rotation.z;
				TweenMax.to(INTERSECTED.userData, 0.5, {
					rotation: (Math.PI / 2) + camera.rotation.z,
					// onUpdate: function () {
					// 	if (INTERSECTED) {
					// 		console.log(INTERSECTED.rotation.z, INTERSECTED.userData.rotation);
					// 		INTERSECTED.quaternion.copy(camera.quaternion);
					// 		INTERSECTED.rotation.z = INTERSECTED.userData.rotation;
					// 	}
					// },
					// onComplete: function () {
					// 	if (INTERSECTED) {
					// 		INTERSECTED.rotation.z = INTERSECTED.userData.initRotationZ;
					// 	}
					// }
				});

				// console.log("INTERSECTED", INTERSECTED.userData);

			} else {
				// TweenMax.to(INTERSECTED.userData, 0.5, {
				// 	rotation: camera.rotation.z
				// });
				intersects[0].object.rotation.z = INTERSECTED.userData.rotation;
			}

		} else {

			if (INTERSECTED)  {
				INTERSECTED.rotation.z = 0;
				// TweenMax.to(INTERSECTED.userData, 0.5, {
				// 	rotation: 0,
				// 	onComplete: () => {
				// 		INTERSECTED = null;
				// 	}
				// });
			}
			INTERSECTED = null;
		}
	}

	/**
	 * get cartesian coordinates from lat and lon and radius
	 * @param lon -180 to 180
	 * @param lat -90 to 90
	 * @param radius
	 * @returns {{x: number, y: number, z: number}}
	 */
	function getCartesianCoordinatesOnSphereFromLonLat(lat, lon, radius) {
		let latitude = Math.max(-90, Math.min(90, lat)),
			phi = THREE.Math.degToRad(90 - latitude),
			theta = THREE.Math.degToRad(lon + 180),
			r = radius || 500;
		return {
			x: r * Math.sin(phi) * Math.cos(theta),
			y: r * Math.cos(phi),
			z: r * Math.sin(phi) * Math.sin(theta)
		};
	}

	/**
	 * get latitude and longitude from cartesian coordinates
	 * @param x
	 * @param y
	 * @param z
	 * @returns {{lat: number, lon: number}}
	 */
	function getLatLonFromCartesianCoordinates(x, y, z, radius) {
		return {
			lat: THREE.Math.radToDeg(Math.asin(z / radius)),
			lon: THREE.Math.radToDeg(Math.atan2(y, x))
		}
	}

	function animate() {
		window.requestAnimationFrame(animate);
		if (run) {
			update();
		}

	}

	function absoluteDiff(a, b) {
		return Math.abs(b - a);
	}

	function generateHotSpots(state) {
		let fabs = getFabs(state, true);

		prevCameraTarget = {
			x: 0,
			y: 0,
			z: 0
		};

		// remove previous hotspots
		// $container.find(".hotspot-label").remove();
		_.forEach(hotspots, spot => {
			layerMesh.remove(spot);
		});
		return _.map(fabs, function (hotspotData) {
			let	hotspot = new THREE.Mesh(hotspotGeometry, hotspotMaterial),
				coords = getCartesianCoordinatesOnSphereFromLonLat(
					hotspotData.fabPosition.lat,
					hotspotData.fabPosition.lon,
					hotspotData.fabPosition.radius - 50);
			hotspot.position.set(coords.x, coords.y, coords.z);
			hotspot.visible = true;
			hotspot.userData = hotspotData;
			layerMesh.add(hotspot);
			// $('<div class="hotspot-label"></div>').data({
			// 	"hotspot": hotspot
			// }).attr({
			// 	"data-fab": JSON.stringify(hotspotData)
			// }).appendTo($container);
			return hotspot;
		});
	}

	function convert3DWorldTo2DScreen(obj, camera, renderer) {
		var vector = new THREE.Vector3(obj.position.x, obj.position.y, obj.position.z);
		var canvas = renderer.domElement;

		// map to normalized device coordinate (NDC) space
		vector.project(camera);

		// map to 2D screen space
		vector.x = Math.round(( vector.x + 1 ) * parseInt(canvas.style.width) / 2);
		vector.y = Math.round(( -vector.y + 1 ) * parseInt(canvas.style.height) / 2);
		vector.z = 0;
		return vector;
	}

	function onDocumentMoveStart(e) {

		e.preventDefault();
		let touch = e.touches,
			x = (touch ? e.touches[0].clientX : e.clientX) - $container.offset().left,
			y = (touch ? e.touches[0].clientY : e.clientY) - $("#configurator-viewers").position().top;

		isUserInteracting = true;

		onPointerDownPointerX = x;
		onPointerDownPointerY = y;

		onPointerDownLon = lon;
		onPointerDownLat = lat;

		mouse.x = ( x / container.clientWidth ) * 2 - 1;
		mouse.y = -( y / container.clientHeight ) * 2 + 1;


		raycaster.setFromCamera(mouse, camera);

		let intersects = raycaster.intersectObjects(hotspots),
			data;

		if (intersects.length > 0) {

			INTERSECTED = intersects[0].object;
			data = intersects[0].object.userData;
			console.log("click", intersects[0].object.userData);
			store.dispatch({
				type: 'ACTIVE_FAB_CHANGE',
				data: intersects[0].object.userData
			});
		}

	}

	function onDocumentMove(e) {
		let touch = e.touches,
			x = (touch ? e.touches[0].clientX : e.clientX) - $container.offset().left,
			y = (touch ? e.touches[0].clientY : e.clientY) - $("#configurator-viewers").position().top;

		if (e.touches && e.touches.length > 1) {
			return;
		}

		if (isUserInteracting === true) {

			//Math.max(-85, Math.min(85, lat)),
			targetLon = ( onPointerDownPointerX - x ) * moveFactor + onPointerDownLon;
			targetLat = Math.max(-90, Math.min(90, ( y - onPointerDownPointerY ) * moveFactor + onPointerDownLat));
			// console.log("targetLon", targetLon, lon)
			// console.log("targetLat", targetLat, lat);
		}

		mouse.x = ( x / container.clientWidth ) * 2 - 1;
		mouse.y = -( y / container.clientHeight ) * 2 + 1;

	}

	function onDocumentMoveEnd() {

		isUserInteracting = false;

	}

	function onDocumentMouseWheel(event) {

		// WebKit

		if (event.wheelDeltaY) {

			camera.fov -= event.wheelDeltaY * 0.05;

			// Opera / Explorer 9

		} else if (event.wheelDelta) {

			camera.fov -= event.wheelDelta * 0.05;

			// Firefox

		} else if (event.detail) {

			camera.fov += event.detail * 1.0;

		}
		// camera fov min = 35
		// camera fov max = 90
		camera.fov = Math.max(35, Math.min(90, camera.fov));
		camera.updateProjectionMatrix();

	}

	/**
	 * get dimensions from a filename
	 * @param filename
	 * @returns {{width: number, height: number, x: number, y: number}|*}
	 */
	function getDimensions(filename) {
		var re = /-(\d+)-(\d+)-(\d+)-(\d+).png/g,
			match = re.exec(filename),
			width = 0,
			height = 0,
			x = 0,
			y = 0,
			dims;

		if (match) {
			width = parseInt(match[1], 10);
			height = parseInt(match[2], 10);
			x = parseInt(match[3], 10);
			y = parseInt(match[4], 10);
		}
		dims = {
			width: width,
			height: height,
			x: x,
			y: y,
		};
		return dims;
	}

	/**
	 * get image data and dims
	 * @param src
	 * @returns {Promise}
	 */
	function getImage(src) {
		let p = new Promise((resolve, reject) => {
			var img = new Image(),
				dims;
			img.crossOrigin = "";
			img.src = src;
			img.onload = function () {
				resolve({
					src,
					img
				});
			};
			img.onerror = (e) => {
				resolve();
			};
		});
		return p;
	}

	/**
	 * draw image layers to canvas, update the webgl texture
	 * @param layers
	 */
	function drawImageLayers(layer) {
		context.fillStyle = "#444444";
		context.fillRect(0, 0, canvasWidth, canvasHeight);
		let promise;
		promise = new Promise((resolve, reject) => {
			return Rx.Observable.fromPromise(getImage(layer)).subscribe(imgData => {
					// console.log(imgData);
					context.drawImage(imgData.img, 0, 0,
						imgData.img.width, imgData.img.height,
						0, 0,
						imgData.img.width, imgData.img.height);
				}, e => {
					console.log(e)
				},
				() => {
					console.log("draw complete")
					layerTexture.needsUpdate = true;
					resolve();
				});
		});

		return promise;
	}

	/**
	 * method to center the view
	 */
	interiorViewer.centerView = () => {
		if (controls) {
			controls.reset();
		} else {
			targetLat = 0;
			targetLon = 0;
		}
	};

	animate();

	/**
	 * repaint the layers given the state of the app
	 * @param state - main state object
	 */
	interiorViewer.update = (state) => {
		let layers = getLayers(state);
		run = (state.view === "interior");
		if (!state.truckModel || !state.truckCab | !run) {
			return;
		}
		radius = state.interiorViewRadius;
		console.log("interior update");
		imgFolder = "/images/configurator-mini/" + convertName(state.truckModel + "-" + state.truckCab) + "-interior/";
		hotspots = generateHotSpots(state);
		updateRendererSize();
		// updateProgress(0, 1, null, false, false);
		$container.addClass("loading");
		Rx.Observable.from(layers)
			.subscribe(layer => {
				//console.log("update", layers);
				Rx.Observable.fromPromise(drawImageLayers(imgFolder + layer)).subscribe(() => {
					// updateProgress(1, 1, null, true, false);
					$container.removeClass("loading");
				});

				// TODO rotate to center of layer - need ADS to be updated first
				// targetLon = (180 * imgData.dims.x);
				//(THREE.Math.RAD2DEG * dims.x * Math.PI) - 180;
				// targetLat = (-imgData.dims.y * 90);
				//THREE.Math.RAD2DEG * Math.atan(Math.exp(-2 * Math.PI * dims.y));
			});
	};

	if (typeof Stats === "function") {
		var stats = new Stats();
		stats.domElement.style.position = 'absolute';
		stats.domElement.style.top = '0px';
		stats.domElement.style.zIndex = 100;
		container.appendChild(stats.domElement);
	}

	function updateRendererSize() {
		camera.aspect = container.clientWidth / container.clientHeight;
		camera.updateProjectionMatrix();
		renderer.setSize(container.clientWidth, container.clientHeight);
	}

	function getLayers(state) {
		// create the layers, order and layer types are hard-coded
		return [
			"interior_" + state.cabType + "_cab.jpg"
		];
	}

	setupViewer();

	return interiorViewer;
}
